import { Component, Prop } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import VueBase from '@/VueBase';
import { locales } from '@/i18n-setup';
import helper, { _loadComponent } from '@/services/helper';
import Q from 'q';
import _ from 'lodash';
import api from '@/services/api';
import { Route, RawLocation } from 'vue-router';
import printerApi from '@/services/printer';
import { AppMode } from '@/Enums';

@Component<FinalConfirmMixins>({
  computed: {
    ...mapState({
      CandidatesPerRow: 'CandidatesPerRow',
      ShowCandidateName: 'ShowCandidateName',
      ShowCandidatePicture: 'ShowCandidatePicture',
      ShowConfirm: 'ShowConfirm',
      ShowSideBar: 'ShowSideBar',
      AnonymousVoteEnabled: 'AnonymousVoteEnabled',
    }),
    ...mapGetters({
      ConfirmData: 'ConfirmData',
    }),
  },
})
export default class FinalConfirmMixins extends VueBase {
  public readonly CandidatesPerRow!: number;
  public readonly ShowCandidateName!: boolean;
  public readonly ShowCandidatePicture!: boolean;
  public readonly ShowConfirm!: boolean;
  public readonly AnonymousVoteEnabled!: boolean;
  public readonly ShowSideBar!: string;

  public readonly ConfirmData!: SubjectSimpleModel[];

  public loading: boolean = true;

  get candidateWidth() {
    return 100.0 / this.CandidatesPerRow;
  }

  get validSubject() {
    return this.ConfirmData.map(
      (x) => x.Data && ((x.Data.length == 0 && x.WhitePaper) || (x.Min <= x.Data.length && x.Data.length <= x.Max)),
    );
  }

  get isValid() {
    return this.validSubject.filter((x) => !x).length == 0;
  }

  get LastSubject() {
    if (this.ConfirmData.length == 0) return '';
    return this.ConfirmData[this.ConfirmData.length - 1].Name;
  }

  async mounted() {
    this.loading = true;
    helper.swalShowLoading();

    await Q.delay(1000);
    this.loading = false;

    helper.close();
    if (!this.ConfirmData.length) {
      this.$router.push({ name: 'Start' });
    }
    this.onLoaded();
    return true;
  }

  // ToOverride if needed
  onLoaded() {}

  public async onGoNext() {
    if (!this.isValid) {
      helper.swalError('Invalid data');
      return;
    }

    helper.swalShowLoading();
    var result: EndVoteItemModel[] = this.ConfirmData.map((x) => ({
      Id: x.Id,
      Candidates: x.Data!.map((c) => c.Id),
      WhitePaper: x.WhitePaper && x.Data?.length == 0,
    }));
    let apiResult = await (await api.VoteSave(result)).getData(true);
    if (!apiResult) {
      await Q.delay(200);
      this.$router.push({ name: 'Start' });
      return;
    }

    if (process.env.VUE_APP_MODE === AppMode.WEB) {
      await api.Logout();
    }

    printerApi.YayaPrintLines(apiResult.PrintLines || []);
    this.$store.commit('SetVotingInfo', []);
    this.$router.push({ name: 'ThankYou' });
  }

  public onGoPrev() {
    this.$router.push({
      name: 'Vote',
      params: { subjectIndex: String(this.ConfirmData.length - 1) },
    });
  }
}
